const GBP = new Intl.NumberFormat(undefined, { currency: 'GBP', style: 'currency' });

export const formatGBP = (value: string | number | undefined | null, opts?: { default: string }) =>
  value === undefined || value === null || Number.isNaN(Number(value))
    ? opts?.default
    : GBP.format(value as Intl.StringNumericLiteral | number);
